// extracted by mini-css-extract-plugin
export default {"grTable":"GroundRentAccruals_grTable__yp641","radioLabel":"GroundRentAccruals_radioLabel__T7Css"};